import React from "react";
import ConfirmActionModal from "components/common/ConfirmActionModal";

export type MaterialRequestCancelConfirmModalProps = {
  show: boolean;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export default function MaterialRequestCancelConfirmModal({
  show,
  submitting,
  onClose,
  onConfirm,
}: MaterialRequestCancelConfirmModalProps) {
  return (
    <ConfirmActionModal
      show={show}
      onClose={() => !submitting && onClose()}
      title="Cancel material request"
      iconClass="ri-close-circle-line"
      iconColor="text-danger"
      heading="Cancel this request?"
      description="This will mark the material request as cancelled. You can only cancel when no stock has been issued."
      confirmText="Cancel request"
      confirmColor="danger"
      cancelText="Keep open"
      confirmDisabled={submitting}
      onConfirm={() => void onConfirm()}
    />
  );
}
